import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const DELETE_VENUE_IMAGE = "VENUE:DELETE_VENUE_IMAGE";

export interface DeleteVenueImageAction extends Action {
  type: typeof DELETE_VENUE_IMAGE;
  id: number;
  organization: OrganizationKeyName;
  imageUrl: string;
}

export const deleteVenueImageAction = (
  organization: OrganizationKeyName,
  id: number,
  imageUrl: string
): DeleteVenueImageAction => ({
  type: DELETE_VENUE_IMAGE,
  id,
  organization,
  imageUrl,
});
